export const compareVersions = (v1, v2) => {
  if (!v1 || !v2) return 0;

  const a = v1.split('.').map(Number);
  const b = v2.split('.').map(Number);

  const maxLength = Math.max(a.length, b.length);

  for (let i = 0; i < maxLength; i++) {
    const num1 = a[i] || 0;
    const num2 = b[i] || 0;

    if (num1 > num2) return 1;
    if (num1 < num2) return -1;
  }

  return 0;
};

export const compareMajorMinorVersions = (v1, v2) => {
  const [major1 = 0, minor1 = 0] = v1.split('.').map(Number);
  const [major2 = 0, minor2 = 0] = v2.split('.').map(Number);

  if (major1 > major2) return 1;
  if (major1 < major2) return -1;

  if (minor1 > minor2) return 1;
  if (minor1 < minor2) return -1;

  return 0;
};

// export const getVersionStatus = (current, latest) => {
//   if (!current || !latest) return "unknown";

//   return compareMajorMinorVersions(current, latest) < 0
//     ? "outdated"
//     : "ok";
// };
export const getVersionStatus = (current, latest) => {
  if (!current || !latest) return "unknown";

  const [currentMajor = 0, currentMinor = 0] =
    current.split(".").map(Number);

  const [latestMajor = 0, latestMinor = 0] =
    latest.split(".").map(Number);

  if (currentMajor < latestMajor) return "outdated";
  if (currentMajor > latestMajor) return "ok";

  return latestMinor - currentMinor > 2
    ? "outdated"
    : "ok";
};